import { Navigate, useLocation } from 'react-router';
import { usePageVersions } from './use-page-versions';

/** Where a V2 account lands instead of a legacy-only page. */
export const V2_HOME = '/app/dashboard/awaiting-actions';

/*
 * Pages that read and write only the legacy system (Mongo, Lambdas). A V2
 * account has nothing there, so it never opens them: not from a link, a
 * search result, a bookmark or a typed URL. Storage providers
 * (/app/scm/storage-provider) and the catalog item page serve V2 and stay.
 */
const LEGACY_ONLY: readonly RegExp[] = [
  /^\/app\/scm\/?$/,
  /^\/app\/scm\/(assign-items|purchase-orders|restock|shipments|supplier|work-orders)(\/|$)/,
  /^\/app\/(crm|wholesale|data-studio|notifications|change-logs)(\/|$)/,
  /^\/app\/dashboard\/logs(\/|$)/,
  /^\/app\/orders\/list\/returns(\/|$)/i,
  /^\/app\/catalogs\/(attributes|classification-guide|components|duplicate-listings|listings|resolve-conflict|settings)(\/|$)/,
];

export const isLegacyOnlyPath = (pathname: string) =>
  LEGACY_ONLY.some(page => page.test(pathname));

/**
 * Sends a V2 account away from a legacy-only page, once the page versions
 * have answered (until then a legacy account would be sent away too).
 */
export function LegacyRouteGuard() {
  const { pathname } = useLocation();
  const { known, isV2 } = usePageVersions();
  return known && isV2('orders') && isLegacyOnlyPath(pathname) ? (
    <Navigate to={V2_HOME} replace />
  ) : null;
}
